module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal_generic",
    class: _vm.cls
  }, [_c('div', {
    staticClass: "modal_dimmer_generic",
    on: {
      "click": function($event) {
        return _vm.dimmerClose()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal_popup_generic"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.killerClose()
      }
    }
  }, [_vm._v("X")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13afa576","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 582
// module chunks = 1